import { useParams } from "@tanstack/react-router";

import axios from "@/apis/custom/axiosConfig";
import { BACKEND_URL } from "@/lib/constants/constants";
import { useTenant } from "@/providers/session";
import { useTranslation } from "react-i18next";

import logo from "./logo.svg";

type Props = {
  clientId: string;
  isDisabled: boolean;
};

export const DatevSignInButton = ({ clientId, isDisabled }: Props) => {
  const { t } = useTranslation();
  const { tenantId } = useTenant();
  const { company: companySlug } = useParams({ strict: false });

  const handlePress = async () => {
    const signInRequest = await axios.get(
      `${BACKEND_URL}/api/auth/datev/login`,
      {
        params: {
          tenantId,
          clientId,
          redirectUrl: `${window.location.origin}/${companySlug}/buchhaltung/einstellungen/integrationen`,
        },
      },
    );

    window.location.assign(signInRequest.data.url);
  };

  const label = t("integrations.datev.connect");

  return (
    <button
      type="button"
      className="datev-btn"
      onClick={handlePress}
      disabled={isDisabled}
    >
      <img src={logo} alt={label} width={40} height={40} />
      <span>{label}</span>
    </button>
  );
};
